import { useQueryStates } from 'src/core/api/hooks/useQueryStates';
import { type QueryState } from 'src/core/api/queryState';

import { useBudgetSuppliers } from './useBudgetSuppliers';
import { useCostCentersQuery, useCustomFieldsQuery } from '../../apis';
import { useExpenseCategoriesQuery } from '../../containers/hooks/useExpenseCategoriesQuery';
import { type BudgetTree } from '../models/budgetTree';
import { type DimensionData } from '../models/dimensionData';

export const useBudgetDimensionData = (
  budgetTreeQueryState: QueryState<BudgetTree<unknown>>,
): QueryState<DimensionData> =>
  // TODO do not fetch advanced dimensions if the feature is disabled
  // const hasAdvancedDimensions = useFeature(
  //   FEATURES.BUDGETS_ADVANCED_DIMENSIONS,
  // );
  // use getDimensions() to know which dimensions to fetch
  useQueryStates({
    states: {
      costCenters: useCostCentersQuery(),
      expenseCategory: useExpenseCategoriesQuery({ withArchived: false }),
      // Advanced dimensions
      customFields: useCustomFieldsQuery(),
      suppliers: useBudgetSuppliers(budgetTreeQueryState),
    },
    reshapeData: ({ costCenters, suppliers, expenseCategory }) => ({
      costCenter: new Map(costCenters.map(({ id, name }) => [id, { name }])),
      expenseCategory: new Map(
        expenseCategory.map(({ id, name }) => [id, { name }]),
      ),
      supplier: new Map(
        suppliers.map(({ id, name, thumbnailUrl }) => [
          id,
          { name, thumbnailUrl },
        ]),
      ),
    }),
  });
